// extracted by mini-css-extract-plugin
export var readonly = "_ie-1";
export var star = "_ie-0";